module.exports = __webpack_public_path__ + "media/img/apple-icon-aa538646c04c18bcf800cc259d428cd2.png";